{
  "appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Rezervovat novou schůzku"
    },
    "meta": {
      "title": "Podrobnosti o schůzce",
      "description": "Veškeré informace o schůzce"
    }
  }
}
